import { CLEAR_ERRORS } from "./types";

// Clear Error
export const clearErrors = () => dispatch => {
  dispatch({
    type: CLEAR_ERRORS
  });
};



// WEBPACK FOOTER //
// ./src/actions/errorAction.js